module.exports = __webpack_public_path__ + "videos/gestures_cn.9e1ef4f.mp4";